import React, { Component } from "react";
import { Alert } from "antd";

class ErrorBoundary extends Component {
  state = { hasError: false, errorInfo: null };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert
          message="Something went wrong."
          description="An unexpected error occurred. Please try again later."
          type="error"
          showIcon
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
